<template>
  <div class="createPlayStep new-input-box" v-loading="loading">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-back @back="returnBack()" :title="['互动广场']" :subTitle="activityData.name" style="padding-bottom: 0"></jd-back>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <jd-tip style="margin-bottom: 10px">云短信CRM ：订购到期时间
          {{ jdCrm.endTime }}（店铺需要搭配云短信CRM使用）。</jd-tip>
        <el-form :model="ruleForm" ref="ruleForm" class="backgroundForm" label-width="150px">
          <!-- 基本信息 -->
          <informationForm @selectPeopleSure="selectPeopleSure"
            :defaultActMember.sync="actMember" :defaultActivityStartTime.sync="activityStartTime"
            :defaultActivityEndTime.sync="activityEndTime" :plusObject.sync="ruleDTO.plusObject"
            :openCardStartTime.sync="ruleDTO.openCardStartTime" :openCardEndTime.sync="ruleDTO.openCardEndTime"
            :peopleSelected.sync="peopleSelected" ref="informationForm" v-model="ruleForm" :isEdit="false"
            :isNeedCusType="true" :cusType.sync="ruleDTO.cusType" :disabled="activityData.isStart"
            :localStepNum="localStepNum" :activityId="87" :showOpenCardTip="true"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <!-- 活动设置 -->
          <jd-title label="答题设置"></jd-title>
          <div class="mt20">
            <el-form-item label="设置题目：" required>
              <div>
                <div class="common-flex1">
                  <jd-button type="blue" :disabled="backgroundOpacity" @click="addQuestion('create')">+添加题目</jd-button>
                  <span style="margin-left: 10px;color: #666;">({{ questionList.length }}/50)</span>
                  <span style="color: #f89f39;margin-left: 10px;">温馨提示：导购题目以简单精炼为主，不宜设置较多题目，3~6题最佳，并且至少添加一个高权重单选题</span>
                </div>
                <div v-if="questionList.length > 0" style="margin-top: 16px;">
                  <el-table :header-cell-style="{
                    background: '#fafafa',
                    'text-align': 'left',
                  }" border :data="questionList" style="width: 1100px" :autoMaxHeight="false" :showPage="false">
                    <el-table-column label="排序" width="50">
                      <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                      </template>
                    </el-table-column>
                    <el-table-column label="题目类型">
                      <template slot-scope="scope">
                        <span v-if="scope.row.type == 1">单选题</span>
                        <span v-else-if="scope.row.type == 4">图片选择题</span>
                        <span v-else>-</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="题目权重">
                      <template slot-scope="scope">
                        <span v-if="scope.row.questionWeight == 1">高权重（硬性约束题）</span>
                        <span v-else-if="scope.row.questionWeight == 2">中权重（核心需求题）</span>
                        <span v-else-if="scope.row.questionWeight == 3">低权重（了解偏好题）</span>
                        <span v-else>-</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="题目名称(50个字以内)">
                      <template slot-scope="scope">
                        {{ scope.row.title }}
                      </template>
                    </el-table-column>
                    <el-table-column label="题目内容">
                      <template slot-scope="scope">
                        <div style="padding: 4px 0px 0px 0px;">
                          <div style="display: flex;align-items: center;margin-bottom: 4px;"
                            v-for="(item, index) in scope.row.options" :key="index">
                            {{ item.level }}、
                            <div v-if="scope.row.type == 1">{{ item.description }}</div>
                            <div v-if="scope.row.type == 4">
                              <img style="width: 32px;height: 32px;" :src="item.picUrl" alt="">
                            </div>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <jd-button :disabled="backgroundOpacity" type="blueText"
                          @click="editQuestion(scope.row, scope.$index)">修改</jd-button>
                        <jd-button :disabled="backgroundOpacity" type="blueText"
                          @click="deleteQuestion(scope.$index)">删除</jd-button>
                        <jd-button :disabled="backgroundOpacity" type="blueText"
                          v-if="scope.$index > 0 && scope.$index <= questionList.length - 1"
                          @click="moveUp(scope.$index)">上移</jd-button>
                        <jd-button :disabled="backgroundOpacity" type="blueText"
                          v-if="scope.$index < questionList.length - 1" @click="moveDown(scope.$index)">下移</jd-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="答题优惠券:" required>
              <el-radio-group :disabled="backgroundOpacity" v-model="ruleDTO.couponMode">
                <el-radio :label="0">不赠送优惠券</el-radio>
                <el-radio :label="1">完成答题后，统一赠送优惠券</el-radio>
                <el-radio :label="2">完成答题后，按主推商品赠送优惠券</el-radio>
              </el-radio-group>
            </el-form-item>

            <template v-if="ruleDTO.couponMode == 1">
              <el-form-item ref="unifiedCouponGrantTypeRef" label="赠券张数:" required>
                <el-radio-group :disabled="backgroundOpacity" v-model="ruleDTO.unifiedCouponGrantType">
                  <el-radio :label="1">每人仅首次完成答题时赠送1张券</el-radio>
                  <!-- <el-radio :label="2">每人每次完成答题都赠送1张券</el-radio>
                  <el-radio :label="3">每人最多仅赠送 <el-input :disabled="backgroundOpacity" style="width: 100px;"
                      v-model="ruleDTO.unifiedCouponGrantMaxCount" type="number" placeholder="请输入"
                      @input="(e) => { ruleDTO.unifiedCouponGrantMaxCount = validSe(e,99999) }" />
                    张券</el-radio> -->
                </el-radio-group>
              </el-form-item>
              <el-form-item ref="formalTableRef" label="优惠券设置:" required>
                <el-table :header-cell-style="{
                  background: '#fafafa',
                  'text-align': 'left',
                }" border :data="formalTable" style="width: 1100px" :autoMaxHeight="false" :showPage="false">
                  <el-table-column label="奖品类型" width="150">
                    <template>
                      <span>优惠券</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="值" width="100" prop="price" align="center"></el-table-column>
                  <el-table-column label="奖品名称（15字内）">
                    <template slot="header">
                      <span style="color:red;">*</span>
                      <span>
                        奖品名称（15字内）
                      </span>
                    </template>
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.title" maxlength="15"
                        :disabled="scope.row.prizeType == 4 || fours == 2" show-word-limit style="width: 230px"
                        placeholder="请输入"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="奖品数量" width="150">
                    <template slot="header">
                      <span style="color:red;">*</span>
                      <span>
                        奖品数量
                      </span>
                    </template>
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.totalAmount"
                        @input="scope.row.totalAmount = getNumberData(1, $event, 0, 1, 999999)" class="inputcount"
                        style="width: 120px" placeholder="请输入"
                        :disabled="!canSelectPrize(scope.row) && !scope.row.minNum"></el-input>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column label="图片" width="150">
                    <template slot-scope="scope">
                      <div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
                        <img v-if="scope.row.logo" :src="scope.row.logo" style="width: 50px; height: 50px" disabled />
                      </div>
                    </template>
                  </el-table-column> -->
                  <el-table-column label="剩余库存" width="180" v-if="isStartEdit">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.remanentAmount" style="width: 70px" disabled></el-input>
                      份
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                      <jd-button type="blueText" :disabled="backgroundOpacity || !canSelectPrize(scope.row)"
                        @click="dialogPrize = true">设置优惠券</jd-button>
                      <jd-button type="blueText" v-if="!backgroundOpacity && !canSelectPrize(scope.row)"
                        @click="itemAddNum('formalTable', scope.$index)">增加奖品数量</jd-button>
                      <jd-button v-if="!canSelectPrize(scope.row)" type="blueText" :disabled="backgroundOpacity"
                        @click="dialogPrize = true">编辑优惠券</jd-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </template>
            <template v-if="ruleDTO.couponMode == 2">
              <el-form-item ref="productCouponGrantTypeRef" label="每券赠送次数:" required>
                <el-radio-group :disabled="backgroundOpacity" v-model="ruleDTO.productCouponGrantType">
                  <el-radio :label="1">每人仅首次主推对应商品时赠送1张券</el-radio>
                  <!-- <el-radio :label="2">每人每次主推对应商品时都赠送1张券</el-radio>
                  <el-radio :label="3">每人每个主推商品最多仅赠送 <el-input :disabled="backgroundOpacity" style="width: 100px;"
                      v-model="ruleDTO.productCouponGrantMaxCount" type="number" placeholder="请输入"
                      @input="(e) => { ruleDTO.productCouponGrantMaxCount = validSe(e,99999) }" />
                    张券</el-radio> -->
                </el-radio-group>
              </el-form-item>
            </template>
          </div>

          <jd-title label="推荐商品设置"></jd-title>
          <div class="mt20">
            <el-form-item ref="orderWareListZRef" label="商品设置:" required>
              <el-table :header-cell-style="{
                background: '#fafafa',
                'text-align': 'left',
              }" border :data="recommendProducts" style="width: 1100px" :autoMaxHeight="false" :showPage="false">
                <el-table-column label="商品名称">
                  <template slot-scope="scope">
                    <div>
                      <div>{{ scope.row.title }}</div>
                      <div v-if="scope.row.jdPrice" style="color:#666;">￥{{ scope.row.jdPrice }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="商品图片" width="100">
                  <template slot-scope="scope">
                    <div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
                      <img v-if="scope.row.logo" :src="scope.row.logo" style="width: 50px; height: 50px" disabled />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="商品标签">
                  <template slot-scope="scope">
                    <div style="display: flex;align-items: center;flex-wrap: wrap;">
                      <div style="white-space: nowrap;" v-for="(item, index) in scope.row.tags" :key="index">
                        <span v-if="findTag(item).type == 1">{{ findTag(item).name }}</span>
                        <span v-else>
                          <img :src="findTag(item).name" style="width: 50px; height: 50px;" alt="">
                        </span>
                        <span v-if="index < scope.row.tags.length - 1">、</span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-if="ruleDTO.couponMode == 2" label="优惠券&总库存">
                  <template slot-scope="scope">
                    <div v-if="scope.row.couponObject.assetsId">
                      <div>{{ scope.row.couponObject.title }}<span style="color:#666" v-if="isStartEdit">(余{{
                        scope.row.couponObject.remanentAmount }}张)</span>
                      </div>
                      <div>
                        <el-input v-model="scope.row.couponObject.totalAmount"
                          @input="scope.row.couponObject.totalAmount = getNumberData(1, $event, 0, 1, 999999)"
                          class="inputcount" style="width: 120px" placeholder="请输入"
                          :disabled="(!canSelectPrize(scope.row) && !scope.row.couponObject.minNum) && scope.row.couponObject.id"></el-input>
                        张
                      </div>
                    </div>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <jd-button :disabled="backgroundOpacity" type="blueText"
                      @click="openGoodsSelect(scope.$index)">选择商品</jd-button>
                    <jd-button :disabled="backgroundOpacity" type="blueText"
                      @click="handleDelete(scope.$index)">删除</jd-button>
                    <jd-button :disabled="backgroundOpacity" type="blueText"
                      @click="setTag(scope.$index, scope.row)">设置标签</jd-button>
                    <jd-button :disabled="backgroundOpacity" @click="openGoodsCoupon(scope.$index)"
                      v-if="ruleDTO.couponMode == 2" type="blueText">设置优惠券</jd-button>
                    <jd-button :disabled="backgroundOpacity" @click="clearCoupon(scope.$index)"
                      v-if="ruleDTO.couponMode == 2" type="blueText">清除优惠券</jd-button>
                    <jd-button type="blueText" v-if="!backgroundOpacity && !canSelectPrize(scope.row.couponObject)"
                      @click="itemAddNumCoupon('recommendProducts', scope.$index)">增加奖品数量</jd-button>
                  </template>
                </el-table-column>
              </el-table>
              <jd-button :disabled="backgroundOpacity" style="margin-top: 10px;" type="blueLine"
                @click="addOrderWare">+添加推荐商品({{
                  recommendProducts.length
                }}/50)</jd-button>
            </el-form-item>
            <el-form-item ref="recommendCountRef" label="推荐商品数:" required>
              <span style="color:#333;">最多按匹配度推荐前 <el-input-number :disabled="backgroundOpacity" :step="1"
                  :precision="0" style="width: 150px;margin: 0 8px;" v-model="ruleDTO.recommendCount"
                  type="number" :min="1" :max="20" placeholder="请输入"
                  @input="(e) => { ruleDTO.recommendCount = validSe(e,99999) }" />
                个商品</span>
            </el-form-item>
            <el-form-item label="兜底策略:" required>
              <el-radio-group :disabled="backgroundOpacity" v-model="ruleDTO.fallbackStrategy">
                <el-radio :label="1">优先放宽次要偏好（即低权重题可不匹配，此类型匹配度要求更高）</el-radio>
                <el-radio :label="2">仅保留约束条件（即仅高权重题匹配即可，此类型匹配度要求相对较低）</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item ref="orderWareListORef" label="兜底商品:" required>
              <jd-button type="blueLine" :disabled="backgroundOpacity" @click="addOrderWareBackstop">+添加商品({{
                fallbackProducts.length }}/30)</jd-button>
              <draggable v-if="fallbackProducts.length > 0" v-model="fallbackProducts" chosen-class="chosen" :scroll="true"
                animation="150" force-fallback="true" @start="isDragging = true" @end="onEnd" class="draggable-box"
                filter=".undraggable">
                <transition-group type="transition">
                  <div v-for="(item, index) in fallbackProducts" :key="item.logo + index"
                    style="display: inline-block; position: relative" class="show_upImg2"
                    :class="[backgroundOpacity ? 'undraggable' : '']">
                    <img :src="item.logo" width="120px" height="120px" style="display: inline-block" />&nbsp;
                    <div class="delectPosible" v-if="!backgroundOpacity">
                      <span class="delectSort">拖动排序</span>
                      <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg"
                        @click.stop="deleteItem(index)" class="delectIcom" />
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </el-form-item>
          </div>

          <!-- 活动页设置 -->
          <activityPageSettings style="min-height: 620px;" :cusTemplateJSON.sync="ruleDTO.cusTemplateJSON"
            :isNeedSetBG="true" :giftList="giftList" :templateId="templateId" :isShowDesignNumber="false"
            previewKey="url" templatekey="imageUrl" :widthNumber="750" :heightNumber="1624" :isCustomPreview="true"
            :downloadTemplateUrl="'https://cdn-image.yucrm.cn/images/dy/quizShopGuide/启动页.psd'"
            designSpecificationsUrl="https://cdn-image.yucrm.cn/images/dy/quizShopGuide/dtdg-qdy.png" themeTitle="主题"
            :defaultRgb="currrentRgb" v-model="customerPaperwork" @selectTemplate="selectTemplate">
            <template #customPreview>
              <launchScreen ref="launchScreen" :ruleForm="customerPaperwork" :cusTemplateJSON="ruleDTO.cusTemplateJSON" />
            </template>
            <template #otherSet>
              <el-form-item label="按钮设置:">
                <div class="upload-box">
                  <el-form-item label="按钮文案：" label-width="120px" required>
                    <div style="display: flex; align-items: center;">
                      <el-input style="width: 280px;" v-model="customerPaperwork.buttonWordText" placeholder="请输入"
                        :disabled="backgroundOpacity" maxlength="8" show-word-limit />
                      <jd-button style="margin-left: 8px;" type="blueText"
                        @click="customerPaperwork.buttonWordText = '开始测试'">重置</jd-button>
                    </div>
                  </el-form-item>
                  <el-form-item label="按钮背景：" label-width="120px" required>
                    <div class="common-flex1">
                      <el-upload class="upload margin-right-8" action="/jd-hd-web/image/upload"
                        :disabled="backgroundOpacity" :show-file-list="false"
                        :before-upload="(file) => beforeUploadCommon(file, 490, 94)" :on-success="(res) => handleUploadCommonSuccess(res, 'url2')
                          ">
                        <jd-button :disabled="backgroundOpacity" type="blue">自定义上传</jd-button>
                      </el-upload>
                      <jd-button type="blueText" style="margin-left: 16px" @click="
                        customerPaperwork.url2 = templateObj.url2
                        " :disabled="backgroundOpacity">重置</jd-button>
                      <span style="color: #999;margin-left: 16px;">
                      尺寸：490px*94px</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="文字颜色：" label-width="120px" required>
                    <div class="common-flex1">
                      <el-color-picker :disabled="backgroundOpacity" v-model="customerPaperwork.rgb2"
                        size="small"></el-color-picker>
                      <jd-button type="blueText" style="margin-left: 16px" @click="
                        customerPaperwork.rgb2 = templateObj.rgb2
                        " :disabled="backgroundOpacity">重置</jd-button>
                    </div>
                  </el-form-item>
                </div>
              </el-form-item>
            </template>
          </activityPageSettings>

          <jd-title label="答题页设置"></jd-title>
          <div class="mt20" style="position: relative;min-height: 615px;">
            <el-form-item label="答题页背景图：">
              <div class="common-flex1">
                <el-upload class="upload margin-right-8" action="/jd-hd-web/image/upload" :disabled="backgroundOpacity"
                  :show-file-list="false" :before-upload="(file) => beforeUploadCommon(file, 750, 1624)" :on-success="(res) => handleUploadCommonSuccess(res, 'answerPageBgImg')
                    ">
                  <jd-button :disabled="backgroundOpacity" type="blue">自定义上传</jd-button>
                </el-upload>
                <jd-button type="blueText" style="margin-left: 16px" @click="
                  customerPaperwork.answerPageBgImg = templateObj.answerPageBgImg
                  " :disabled="backgroundOpacity">重置</jd-button>
                <jd-button type="blueText"
                  @click="downPsd('https://cdn-image.yucrm.cn/images/dy/quizShopGuide/答题页.psd')"
                  :disabled="backgroundOpacity">下载模板</jd-button>
                <jd-button type="blueText" label="查看设计规范" style="margin: 0 12px"
                  @click="isOpenDesign = true, designUrl = 'https://cdn-image.yucrm.cn/images/dy/quizShopGuide/dtdg-dty.png'"
                  :disabled="backgroundOpacity"></jd-button>
              </div>
            </el-form-item>

            <el-form-item label="题目设置：">
              <div style="background: #f4f6fa;padding: 20px 20px 4px 0;width: fit-content;">
                <el-form-item label="背景：" label-width="80px">
                  <div class="common-flex1">
                    <el-color-picker :disabled="backgroundOpacity" v-model="customerPaperwork.answerTitleBgColor"
                      size="small"></el-color-picker>
                    <jd-button type="blueText" style="margin-left: 16px" @click="
                      customerPaperwork.answerTitleBgColor = templateObj.answerTitleBgColor
                      " :disabled="backgroundOpacity">重置</jd-button>
                  </div>
                </el-form-item>
                <el-form-item label="文字：" label-width="80px">
                  <div class="common-flex1">
                    <el-color-picker :disabled="backgroundOpacity" v-model="customerPaperwork.answerTitleWordColor"
                      size="small"></el-color-picker>
                    <jd-button type="blueText" style="margin-left: 16px" @click="
                      customerPaperwork.answerTitleWordColor = templateObj.answerTitleWordColor
                      " :disabled="backgroundOpacity">重置</jd-button>
                  </div>
                </el-form-item>
              </div>
            </el-form-item>

            <el-form-item label="选项未选中状态：">
              <div style="background: #f4f6fa;padding: 20px 20px 4px 0;width: fit-content;">
                <el-form-item label="背景：" label-width="80px">
                  <div class="common-flex1">
                    <el-color-picker :disabled="backgroundOpacity" v-model="customerPaperwork.optionUnselectedBgColor"
                      size="small"></el-color-picker>
                    <jd-button type="blueText" style="margin-left: 16px" @click="
                      customerPaperwork.optionUnselectedBgColor = templateObj.optionUnselectedBgColor
                      " :disabled="backgroundOpacity">重置</jd-button>
                  </div>
                </el-form-item>
                <el-form-item label="文字：" label-width="80px">
                  <div class="common-flex1">
                    <el-color-picker :disabled="backgroundOpacity" v-model="customerPaperwork.optionUnselectedWordColor"
                      size="small"></el-color-picker>
                    <jd-button type="blueText" style="margin-left: 16px" @click="
                      customerPaperwork.optionUnselectedWordColor = templateObj.optionUnselectedWordColor
                      " :disabled="backgroundOpacity">重置</jd-button>
                  </div>
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item label="选项选中状态：">
              <div style="background: #f4f6fa;padding: 20px 20px 4px 0;width: fit-content;">
                <el-form-item label="背景：" label-width="80px">
                  <div class="common-flex1">
                    <el-color-picker :disabled="backgroundOpacity" v-model="customerPaperwork.optionSelectedBgColor"
                      size="small"></el-color-picker>
                    <jd-button type="blueText" style="margin-left: 16px" @click="
                      customerPaperwork.optionSelectedBgColor = templateObj.optionSelectedBgColor
                      " :disabled="backgroundOpacity">重置</jd-button>
                  </div>
                </el-form-item>
                <el-form-item label="文字：" label-width="80px">
                  <div class="common-flex1">
                    <el-color-picker :disabled="backgroundOpacity" v-model="customerPaperwork.optionSelectedWordColor"
                      size="small"></el-color-picker>
                    <jd-button type="blueText" style="margin-left: 16px" @click="
                      customerPaperwork.optionSelectedWordColor = templateObj.optionSelectedWordColor
                      " :disabled="backgroundOpacity">重置</jd-button>
                  </div>
                </el-form-item>
                <el-form-item label="icon：" label-width="80px">
                  <div class="common-flex1">
                    <el-upload class="upload margin-right-8" action="/jd-hd-web/image/upload" :disabled="backgroundOpacity"
                      :show-file-list="false" :before-upload="(file) => beforeUploadCommon(file, 60, 60)" :on-success="(res) => handleUploadCommonSuccess(res, 'optionSelectedIcon')
                        ">
                      <div>
                        <img :src="customerPaperwork.optionSelectedIcon" alt="" style="width: 60px;height: 60px;">
                      </div>
                      <!-- <jd-button :disabled="backgroundOpacity" type="blue">自定义上传</jd-button> -->
                    </el-upload>
                    <jd-button type="blueText" style="margin-left: 16px"
                      @click="customerPaperwork.optionSelectedIcon = templateObj.optionSelectedIcon"
                      :disabled="backgroundOpacity">重置</jd-button>
                    <span style="color: #999;margin-left: 16px;">格式：jpg,png,jpeg，尺寸：60px*60px</span>
                  </div>
                </el-form-item>
              </div>
            </el-form-item>

            <div style="position: absolute;top: 0;left: 900px;min-height: 615px;">
              <answerPage :ruleForm="customerPaperwork" :questionList="questionList"></answerPage>
            </div>
          </div>

          <jd-title label="过渡页设置"></jd-title>
          <div class="mt20" style="position: relative;min-height: 615px;">
            <el-form-item ref="transitionPageTextRef" label="匹配中文案：" required>
              <div class="common-flex1">
                <el-input maxlength="30" show-word-limit style="width: 400px" :disabled="backgroundOpacity"
                  v-model="customerPaperwork.transitionPageText" placeholder="请输入"></el-input>
                <jd-button type="blueText" style="margin-left: 16px"
                  @click="customerPaperwork.transitionPageText = '正在根据你的答案匹配好物…'"
                  :disabled="backgroundOpacity">重置</jd-button>
              </div>
            </el-form-item>
            <el-form-item label="匹配中效果：" required>
              <div style="background: #f4f6fa;padding: 20px 20px 4px 0;width: fit-content;">
                <el-form-item label="背景颜色：" label-width="100px">
                  <div class="common-flex1">
                    <el-color-picker :disabled="backgroundOpacity" v-model="customerPaperwork.transitionPageBgTopColor"
                      size="small" style="margin-right: 8px;"></el-color-picker>
                    <el-color-picker :disabled="backgroundOpacity"
                      v-model="customerPaperwork.transitionPageBgBottomColor" size="small"></el-color-picker>
                    <jd-button type="blueText" style="margin-left: 16px" @click="
                      customerPaperwork.transitionPageBgTopColor = templateObj.transitionPageBgTopColor
                      customerPaperwork.transitionPageBgBottomColor = templateObj.transitionPageBgBottomColor
                      " :disabled="backgroundOpacity">重置</jd-button>
                    <span style="color: #999;margin-left: 16px;">支持渐变色</span>
                  </div>
                </el-form-item>
                <el-form-item label="文字颜色：" label-width="100px">
                  <div class="common-flex1">
                    <el-color-picker :disabled="backgroundOpacity" v-model="customerPaperwork.transitionPageWordColor"
                      size="small"></el-color-picker>
                    <jd-button type="blueText" style="margin-left: 16px" @click="
                      customerPaperwork.transitionPageWordColor = templateObj.transitionPageWordColor
                      " :disabled="backgroundOpacity">重置</jd-button>
                  </div>
                </el-form-item>
                <el-form-item label="匹配中gif：" label-width="100px">
                  <div class="common-flex1">
                    <el-upload class="upload margin-right-8" action="/jd-hd-web/image/upload" :disabled="backgroundOpacity"
                      :show-file-list="false" :before-upload="(file) => beforeUploadCommon(file, 386, 222)"
                      :on-success="(res) => handleUploadCommonSuccess(res, 'transitionPageIcon')">
                      <div>
                        <img :src="customerPaperwork.transitionPageIcon" alt="" style="width: 60px;height: 60px;">
                      </div>
                      <!-- <jd-button :disabled="backgroundOpacity" type="blue">自定义上传</jd-button> -->
                    </el-upload>
                    <jd-button type="blueText" style="margin-left: 16px"
                      @click="customerPaperwork.transitionPageIcon = templateObj.transitionPageIcon"
                      :disabled="backgroundOpacity">重置</jd-button>
                    <span style="color: #999;margin-left: 16px;">格式：gif，尺寸：386px*222px</span>
                  </div>
                </el-form-item>
              </div>
            </el-form-item>
            <div style="position: absolute;top: 0;left: 900px;min-height: 615px;">
              <filterPage :ruleForm="customerPaperwork"></filterPage>
            </div>
          </div>
          <jd-title label="导购页设置"></jd-title>
          <div class="mt20" style="position: relative;min-height: 615px;">
            <el-form-item ref="matchSuccessfulRef" label="匹配成功文案：" required>
              <div class="common-flex1">
                <el-input maxlength="10" show-word-limit style="width: 165px" :disabled="backgroundOpacity"
                  v-model="customerPaperwork.matchSuccessfulOne" placeholder="请输入"></el-input>
                <span style="margin: 0 8px;color: #333;">高权重题目选项</span>
              </div>
              <div class="common-flex1">
                <el-input maxlength="10" show-word-limit style="width: 165px" :disabled="backgroundOpacity"
                  v-model="customerPaperwork.matchSuccessfulTwo" placeholder="请输入"></el-input>
                <span style="margin: 0 8px;color: #333;">适配结论</span>
                <el-input maxlength="10" show-word-limit style="width: 165px" :disabled="backgroundOpacity"
                  v-model="customerPaperwork.matchSuccessfulThree" placeholder="请输入"></el-input>
                <jd-button type="blueText" style="margin-left: 16px"
                  @click="customerPaperwork.matchSuccessfulOne = '您是'; customerPaperwork.matchSuccessfulTwo = '适合'; customerPaperwork.matchSuccessfulThree = '产品'"
                  :disabled="backgroundOpacity">重置</jd-button>
              </div>
            </el-form-item>
            <el-form-item ref="similarGoodRef" label="相似好物文案：" required>
              <div class="common-flex1">
                <el-input maxlength="50" show-word-limit style="width: 400px" :disabled="backgroundOpacity"
                  v-model="customerPaperwork.similarGood" placeholder="请输入"></el-input>
                <jd-button type="blueText" style="margin-left: 16px"
                  @click="customerPaperwork.similarGood = '暂未找到完全贴合你偏好的商品，为你精选相似好物供你挑选'"
                  :disabled="backgroundOpacity">重置</jd-button>
              </div>
            </el-form-item>
            <el-form-item ref="shopSpotlightRef" label="店铺爆款文案：" required>
              <div class="common-flex1">
                <el-input maxlength="50" show-word-limit style="width: 400px" :disabled="backgroundOpacity"
                  v-model="customerPaperwork.shopSpotlight" placeholder="请输入"></el-input>
                <jd-button type="blueText" style="margin-left: 16px"
                  @click="customerPaperwork.shopSpotlight = '暂时没有匹配你选择偏好的商品，为你推荐店铺高人气爆款'"
                  :disabled="backgroundOpacity">重置</jd-button>
              </div>
            </el-form-item>
            <el-form-item label="导购页背景图：">
              <div class="common-flex1">
                <el-upload class="upload margin-right-8" action="/jd-hd-web/image/upload" :disabled="backgroundOpacity"
                  :show-file-list="false" :before-upload="(file) => beforeUploadCommon(file, 750, 1624)" :on-success="(res) => handleUploadCommonSuccess(res, 'guidePageBgImg')
                    ">
                  <div>
                    <jd-button :disabled="backgroundOpacity" type="blue">自定义上传</jd-button>
                  </div>
                </el-upload>
                <jd-button type="blueText" style="margin-left: 16px"
                  @click="customerPaperwork.guidePageBgImg = templateObj.guidePageBgImg"
                  :disabled="backgroundOpacity">重置</jd-button>
                <jd-button type="blueText" style="margin-left: 8px"
                  @click="downPsd('https://cdn-image.yucrm.cn/images/dy/quizShopGuide/导购页.psd')"
                  :disabled="backgroundOpacity">下载模板</jd-button>
                <jd-button type="blueText" style="margin-left: 8px"
                  @click="isOpenDesign = true, designUrl = 'https://cdn-image.yucrm.cn/images/dy/quizShopGuide/dtdg-jgy-xg.png'"
                  :disabled="backgroundOpacity">查看设计规范</jd-button>
              </div>
            </el-form-item>
            <el-form-item label="结果文案颜色：">
              <div class="common-flex1">
                <el-color-picker :disabled="backgroundOpacity" v-model="customerPaperwork.guideResultWordColor"
                  size="small"></el-color-picker>
                <jd-button type="blueText" style="margin-left: 16px"
                  @click="customerPaperwork.guideResultWordColor = '#1A1A1A'"
                  :disabled="backgroundOpacity">重置</jd-button>
              </div>
            </el-form-item>
            <el-form-item label="标签效果配置：">
              <div style="background: #f4f6fa;padding: 20px 20px 4px 0;width: fit-content;">
                <el-form-item ref="guideRecommendTagRef" label="推荐标签文案：" label-width="180px" required>
                  <div class="common-flex1">
                    <el-input maxlength="8" show-word-limit style="width: 300px" :disabled="backgroundOpacity"
                      v-model="customerPaperwork.guideRecommendTag" placeholder="请输入"></el-input>
                    <jd-button type="blueText" style="margin-left: 16px"
                      @click="customerPaperwork.guideRecommendTag = '为您定制'" :disabled="backgroundOpacity">重置</jd-button>
                  </div>
                </el-form-item>
                <el-form-item ref="similarGoodTagRef" label="相似好物标签文案：" label-width="180px" required>
                  <div class="common-flex1">
                    <el-input maxlength="8" show-word-limit style="width: 300px" :disabled="backgroundOpacity"
                      v-model="customerPaperwork.similarGoodTag" placeholder="请输入"></el-input>
                    <jd-button type="blueText" style="margin-left: 16px"
                      @click="customerPaperwork.similarGoodTag = '相似好物'" :disabled="backgroundOpacity">重置</jd-button>
                  </div>
                </el-form-item>
                <el-form-item ref="shopSpotlightTagRef" label="店铺爆款标签文案：" label-width="180px" required>
                  <div class="common-flex1">
                    <el-input maxlength="8" show-word-limit style="width: 300px" :disabled="backgroundOpacity"
                      v-model="customerPaperwork.shopSpotlightTag" placeholder="请输入"></el-input>
                    <jd-button type="blueText" style="margin-left: 16px"
                      @click="customerPaperwork.shopSpotlightTag = '店铺爆款'" :disabled="backgroundOpacity">重置</jd-button>
                  </div>
                </el-form-item>
                <el-form-item label="标签背景图：" label-width="180px">
                  <div class="common-flex1">
                    <el-upload class="upload margin-right-8" action="/jd-hd-web/image/upload" :disabled="backgroundOpacity"
                      :show-file-list="false" :before-upload="(file) => beforeUploadCommon(file, 336, 72)" :on-success="(res) => handleUploadCommonSuccess(res, 'guideTagBgImg')
                        ">
                      <div style="">
                        <jd-button :disabled="backgroundOpacity" type="blue">自定义上传</jd-button>
                      </div>
                    </el-upload>
                    <jd-button type="blueText" style="margin-left: 16px"
                      @click="customerPaperwork.guideTagBgImg = templateObj.guideTagBgImg"
                      :disabled="backgroundOpacity">重置</jd-button>
                    <span style="color: #999;margin-left: 16px;">尺寸建议：336px*72px</span>
                  </div>
                </el-form-item>
                <el-form-item label="标签文字颜色：" label-width="180px">
                  <div class="common-flex1">
                    <el-color-picker :disabled="backgroundOpacity" v-model="customerPaperwork.guideTagWordColor"
                      size="small"></el-color-picker>
                    <jd-button type="blueText" style="margin-left: 16px"
                      @click="customerPaperwork.guideTagWordColor = templateObj.guideTagWordColor"
                      :disabled="backgroundOpacity">重置</jd-button>
                  </div>
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item label="主按钮设置：">
              <div style="background: #f4f6fa;padding: 20px 20px 4px 0;width: fit-content;">
                <el-form-item label="背景：" label-width="80px">
                  <div class="common-flex1">
                    <el-upload class="upload margin-right-8" action="/jd-hd-web/image/upload" :disabled="backgroundOpacity"
                      :show-file-list="false" :before-upload="(file) => beforeUploadCommon(file, 350, 102)" :on-success="(res) => handleUploadCommonSuccess(res, 'guideMainButtonBgImg')
                        ">
                      <div style="">
                        <jd-button :disabled="backgroundOpacity" type="blue">自定义上传</jd-button>
                      </div>
                    </el-upload>
                    <jd-button type="blueText" style="margin-left: 16px"
                      @click="customerPaperwork.guideMainButtonBgImg = templateObj.guideMainButtonBgImg"
                      :disabled="backgroundOpacity">重置</jd-button>
                    <span style="color: #999;margin-left: 16px;">尺寸建议：350px*102px</span>
                  </div>
                </el-form-item>
                <el-form-item label="文字：" label-width="80px">
                  <div class="common-flex1">
                    <el-color-picker :disabled="backgroundOpacity" v-model="customerPaperwork.guideMainButtonWordColor"
                      size="small"></el-color-picker>
                    <jd-button type="blueText" style="margin-left: 16px"
                      @click="customerPaperwork.guideMainButtonWordColor = templateObj.guideMainButtonWordColor"
                      :disabled="backgroundOpacity">重置</jd-button>
                  </div>
                </el-form-item>
                <el-form-item label="手势：" label-width="80px">
                  <div class="common-flex1">
                    <el-upload class="upload margin-right-8" action="/jd-hd-web/image/upload" :disabled="backgroundOpacity"
                      :show-file-list="false" :before-upload="(file) => beforeUploadCommon(file, 200, 200)" :on-success="(res) => handleUploadCommonSuccess(res, 'guideMainPointerIcon')
                        ">
                      <div>
                        <img :src="customerPaperwork.guideMainPointerIcon" alt="" style="width: 60px;height: 60px;">
                      </div>

                    </el-upload>
                    <jd-button type="blueText" style="margin-left: 16px"
                      @click="customerPaperwork.guideMainPointerIcon = templateObj.guideMainPointerIcon"
                      :disabled="backgroundOpacity">重置</jd-button>
                    <span style="color: #999;margin-left: 16px;">格式：gif，尺寸建议：200px*200px</span>
                  </div>
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item label="辅按钮设置：">
              <div style="background: #f4f6fa;padding: 20px 20px 4px 0;width: fit-content;">
                <el-form-item label="背景：" label-width="80px">
                  <div style="display: flex;align-items: center;">
                    <el-upload class="upload margin-right-8" action="/jd-hd-web/image/upload" :disabled="backgroundOpacity"
                      :show-file-list="false" :before-upload="(file) => beforeUploadCommon(file, 286, 102)" :on-success="(res) => handleUploadCommonSuccess(res, 'guideSubButtonBgImg')
                        ">
                      <div>
                        <jd-button :disabled="backgroundOpacity" type="blue">自定义上传</jd-button>
                      </div>
                    </el-upload>
                    <jd-button type="blueText" style="margin-left: 16px"
                      @click="customerPaperwork.guideSubButtonBgImg = templateObj.guideSubButtonBgImg"
                      :disabled="backgroundOpacity">重置</jd-button>

                    <span style="color: #999;margin-left: 16px;">尺寸建议：286px*102px</span>
                  </div>
                </el-form-item>
                <el-form-item label="文字：" label-width="80px">
                  <div class="common-flex1">
                    <el-color-picker :disabled="backgroundOpacity" v-model="customerPaperwork.guideSubButtonWordColor"
                      size="small"></el-color-picker>
                    <jd-button type="blueText" style="margin-left: 16px"
                      @click="customerPaperwork.guideSubButtonWordColor = templateObj.guideSubButtonWordColor"
                      :disabled="backgroundOpacity">重置</jd-button>
                  </div>
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item label="文字按钮颜色：">
              <div class="common-flex1">
                <el-color-picker :disabled="backgroundOpacity" v-model="customerPaperwork.guideWordColor"
                  size="small"></el-color-picker>
                <jd-button type="blueText" style="margin-left: 16px" @click="customerPaperwork.guideWordColor = templateObj.guideWordColor"
                  :disabled="backgroundOpacity">重置</jd-button>
              </div>
            </el-form-item>

            <div style="position: absolute;top: 0;left: 900px;min-height: 615px;">
              <guidePage :orderWareList="recommendProducts" :questionList="questionList" :ruleForm="customerPaperwork" />
            </div>
          </div>

          <!-- <jd-title label='进店设置' type="bold"></jd-title>
          <div class="mt20">
            <el-form-item label="进店逛逛:">
              <el-radio-group v-model="ruleForm.goShopSetting" :disabled="activityData.isStart"
                @change="onShopSetChange">
                <el-radio :label="0">进入店铺首页</el-radio>
                <el-radio :label="1">跳转指定小程序</el-radio>
                <el-radio :label="2">进入指定链接</el-radio>
              </el-radio-group>
              <div style="color:#F56C6C">部分活动需要配合曝光商品使用，如幸运抽奖、裂变神券</div>
            </el-form-item>
            <div v-if="ruleForm.goShopSetting == 1">
              <el-form-item label="小程序appId:" required>
                <el-input type="textarea" placeholder="请输入小程序appId" style="width: 425px;margin-left:8px;"
                  show-word-limit v-model="ruleForm.goShopAppId" :maxlength="1000"
                  :disabled="activityData.isStart"></el-input>
              </el-form-item>
              <el-form-item label="页面路径path:">
                <el-input type="textarea" placeholder="请输入小程序页面路径path" style="width: 425px;margin-left:8px;"
                  show-word-limit v-model="ruleForm.goShopUrl" :maxlength="1000"
                  :disabled="activityData.isStart"></el-input>
                <div style="color:#F56C6C">注意：path若不写，则默认进入小程序主页。</div>
              </el-form-item>
            </div>
            <el-form-item label="指定链接:" required v-if="ruleForm.goShopSetting == 2">
              <el-input type="textarea" placeholder="请输入指定链接" style="width: 425px;margin-left:8px;" show-word-limit
                v-model="ruleForm.goShopUrl" :maxlength="1000" :disabled="activityData.isStart"></el-input>
              <div style="color:#F56C6C">注意：仅可填写京东域内的 H5页面地址，不可设置外链。参考链接：https://m.jd.com/。</div>
            </el-form-item>
          </div> -->

          <sharFrom v-model="ruleForm" :sharePic="sharePic" />
          <jd-title label='其他设置' type="bold"></jd-title>
          <!-- 新增字段 -->
          <el-form-item label="是否重点活动:" required>
            <div class="flexc-cen-x mt10">
              <el-radio-group v-model="isKeyActivity" :disabled="isDisabledNew">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
              <el-tooltip class="item" effect="dark" placement="top">
                <template slot="content">
                  <div>
                    大促、品牌高流量等活动建议选「是」，官方会有一定的技术保障资源倾斜
                  </div>
                </template>
                <i class="new-icon-box ml8"></i>
              </el-tooltip>
            </div>
          </el-form-item>
          <el-form-item label="活动投放位置:" required>
            <el-checkbox-group v-model="placementPosition" :disabled="isDisabledNew">
              <el-checkbox label="HOME">京东APP首场曝光位</el-checkbox>
              <el-checkbox label="CHANNEL">大促主会场资源</el-checkbox>
              <el-checkbox label="SEARCH_RECOMMEND">搜索与推荐链路</el-checkbox>
              <el-checkbox label="SHOP">店铺</el-checkbox>
              <el-checkbox label="OUTSIDE">域外曝光</el-checkbox>
              <el-checkbox label="OTHER">其他渠道</el-checkbox>
              <el-tooltip class="item" effect="dark" placement="top">
                <template slot="content">
                  <div>上方选择为【是】时请选择活动投放位置便于官方监控流量</div>
                </template>
                <i class="new-icon-box ml8"></i>
              </el-tooltip>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0 || localStepNum == 1">
      <jd-button v-if="localStepNum != 0" style="margin-right: 8px" @click="clickLocalStep()">{{ backgroundOpacity ?
        "返回列表" : "返回上一步" }}</jd-button>
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn">保存至草稿箱</jd-button>
      <template v-if="!backgroundOpacity">
        <jd-button v-if="isSave" type="blue" @click="resetForm" v-preventReClick>保存设置</jd-button>
      </template>
    </div>


    <!-- 保存设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800" @close="checked = false">
      <div v-loading="saveLoading">
        <div style="line-height: 25px; margin-bottom: 30px">
          <p>
            1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
          </p>
          <p>
            2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
          </p>
        </div>
        <el-checkbox v-model="checked" label="地址" name="partner">我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox>
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button @click="handleDialogCloseAnoth()" type="blue" style="margin-left: 8px" v-loading="saveLoading">确
          定</jd-button>
      </div>
    </el-dialog>
    <!-- 选择优惠券 -->
    <selectPrize v-model="dialogPrize" @closePrize="closePrize"></selectPrize>
    <selectPrize v-model="dialogCoupon" @closePrize="closeCoupon"></selectPrize>
    <questionDailog :type="questionType" :visible="questionDailogVisible" :questionData="questionData"
      @close="questionDailogVisible = false" @comfirm="handleComfirm" />
    <!-- 选择奖品弹窗 -->
    <selectProduct ref="selectProduct" @choose-shop="getTheData">
    </selectProduct>
    <!-- 标签弹窗 -->
    <tagDailog ref="tagDailog" :visible="tagDailogVisible" :questionList="questionList"
      @close="tagDailogVisible = false" @comfirm="handleTagComfirm"></tagDailog>

    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />

  <!-- 选择商品弹窗 -->
  <selectGoods
    v-if="isShowCustomMarketingGoods"
    :isShow="isShowCustomMarketingGoods"
    :selectGoods="[]"
    :skuSearch="true"
    @close="selectGoodsChangeCustomMarketingGoods"
    :selectOne="true"
    :moduleType="true"
  ></selectGoods>
  <!-- 选择兜底商品弹窗 -->
  <selectGoods
    v-if="isShowfallbackProducts"
    :isShow="isShowfallbackProducts"
    :selectGoods="fallbackProducts"
    :skuSearch="true"
    :moduleType="true"
    @close="selectfallbackProductsGoods"
    :limitNum="30"
  ></selectGoods>

  		<div class="design" v-show="isOpenDesign">
			<div class="design-box">
				<i class="el-icon-close design-close" @click="isOpenDesign = false"></i>
				<img :src="designUrl" alt="" class="design-url">
			</div>
		</div>
  </div>

</template>
<script>
import { useValidateBasicInformation } from "./components/commDataHook/useBasicInformation.js";
import { setBasicInformation,useUpdateBasicInformation } from "./components/commDataHook/useAnswerGuideData.js";
import selectProduct from "./select_product";
import { useJdCrm } from "./components/commDataHook/useCommReq.js";
import informationForm from "./components/informationForm.vue";
import selectPrize from "@/views/interactiveMarketing/activity/select_prize.vue";
import questionDailog from "./components/questionDailog.vue";
import tagDailog from "./components/tagDailog.vue";
import draggable from 'vuedraggable';
import activityPageSettings from "./components/activityPageSettings.vue";
import sharFrom from "./components/sharFrom.vue";
import launchScreen from './components/launchScreen.vue';
import answerPage from './components/answerPage.vue';
import filterPage from './components/filterPage.vue';
import guidePage from './components/guidePage.vue';
import { sellerImage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import { saveOrUpdateAnswerGuide, getAnswerGuideDetail } from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
import addPrizeNum from "./components/add-prize-num.vue";
import selectGoods from "@/components/selectGoodsMonitor2";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";

export default {
  components: {
    informationForm,
    selectProduct,
    selectPrize,
    questionDailog,
    tagDailog,
    activityPageSettings,
    sharFrom,
    launchScreen,
    answerPage,
    filterPage,
    guidePage,
    addPrizeNum,
    selectGoods
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    valueRow: {
      type: Object,
      default: () => { },
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isDraft: false,
      isShowfallbackProducts: false,
      couponIndex: null,
      isShowCustomMarketingGoods: false,
      toAddBelong: "",
      toAddIndex:null,
      isShowAddNum: false,
      toAddItem: {},
      isOpenDesign: false,
      actMember: "1",
      isKeyActivity: 0,
      placementPosition: [],
      sharePic: "https://cdn-image.yucrm.cn//hd/images/13315956_014a3db28f14478aa18b6d53b93bfd4c.png", // 初始图
      designUrl: "",
      customerPaperwork: {
        title: "", //主题
        desc: "", //描述
        rgb2: "#ffffff", //按钮文案颜色
        url: "https://cdn-image.yucrm.cn/b468ddceea7241609d68a4796e357e3d.png",
        url2: "https://cdn-image.yucrm.cn/images/dy/quizShopGuide/activity_page_btn_bg.png",
        titleColor: "#ffffff", //主题字体颜色
        buttonWordText: "开始测试", //按钮文案
        answerPageBgImg: "https://cdn-image.yucrm.cn/images/dy/quizShopGuide/answer_page_bg.png",
        answerTitleBgColor: "#E3F0FE",
        answerTitleWordColor: "#1A1A1A",
        optionUnselectedBgColor: "#FDFAEF",
        optionUnselectedWordColor: "#1A1A1A",
        optionSelectedBgColor: "#FDFAEF",
        optionSelectedWordColor: "#1A1A1A",
        optionSelectedIcon: "https://cdn-image.yucrm.cn/images/dy/quizShopGuide/option_selected_icon.png",
        transitionPageText: "正在根据你的答案匹配好物…",
        transitionPageBgTopColor: "#C7E7FD",
        transitionPageBgBottomColor: "#C7E7FD",
        transitionPageWordColor: "#000",
        transitionPageIcon: "https://cdn-image.yucrm.cn/images/dy/quizShopGuide/transition_page_icon.gif",
        matchSuccessfulOne: "您是",
        matchSuccessfulTwo: "适合",
        matchSuccessfulThree: "产品",
        similarGood: "暂未找到完全贴合你偏好的商品，为你精选相似好物供你挑选",
        shopSpotlight: "暂时没有匹配你选择偏好的商品，为你推荐店铺高人气爆款",
        guidePageBgImg: "https://cdn-image.yucrm.cn/images/dy/quizShopGuide/guide_page_bg.png",
        guideResultWordColor: "#1A1A1A",
        guideRecommendTag: "为您定制",
        similarGoodTag: "相似好物",
        shopSpotlightTag: "店铺爆款",
        guideTagBgImg: "https://cdn-image.yucrm.cn/images/dy/quizShopGuide/guide_tag_bg.png",
        guideTagWordColor: "#1A1A1A",
        guideSubButtonWordColor: "#333",
        guideSubButtonBgImg: "https://cdn-image.yucrm.cn/images/dy/quizShopGuide/guide_sub_btn_bg.png",
        guideWordColor: "#fff",
        guideMainButtonBgImg: "https://cdn-image.yucrm.cn/images/dy/quizShopGuide/guide_main_btn_bg.png",
        guideMainButtonWordColor: "#fff",
        guideMainPointerIcon: "https://cdn-image.yucrm.cn/images/dy/quizShopGuide/poniter_icon.gif",
      },
      prizeIndex: null,
      fallbackProducts: [],
      recommendProducts: [
        {
          wareId: null,
          skuId: null,
          title: null,
          logo: "",
          price: null,
          prizeId: null,
          type: 0,
          sort: null,
          tags: [], // 标签
          couponObject: {
            sort: null,
            assetsId: null, // 资产项id(计划id优惠卷id商品id)
            prizeType: null, // 类型 固定为实物
            price: null, // 价格
            title: "", // 商品标题
            totalAmount: null, // 总共奖品数量
            singleAmount: 1, // 单份奖品数量 固定为1
            logo: null, // 自定义商品图片
            giftType: 1, //实物类型
            prizeObjectType: 10, //正装商品
            percentage: null, // 中奖率
            isShow: 1
          },
        }
      ],
      questionIndex: null,
      questionData: {},
      questionType: '',
      questionDailogVisible: false,
      dialogPrize: false,
      dialogCoupon: false,
      questionList: [],
      jdCrm: {
        endTime: "",
      },
      formalTable: [
        {
          sort: 0,
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null, // 类型 固定为实物
          price: null, // 价格
          title: "", // 商品标题
          totalAmount: null, // 总共奖品数量
          singleAmount: 1, // 单份奖品数量 固定为1
          logo: null, // 自定义商品图片
          giftType: 1, //实物类型
          prizeObjectType: 10, //正装商品
          percentage: null, // 中奖率
          isShow: 1
        },
      ],
      peopleSelected: [],
      checked: false,
      joinBlackList: false,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      saveLoading: false,
      loading: false,
      ruleDTO: {
        openCardStartTime:"",
        openCardEndTime:"",

        couponMode: 0,
        unifiedCouponGrantType: 1,
        unifiedCouponGrantMaxCount: null,
        productCouponGrantType: 1,
        productCouponGrantMaxCount: null,

        recommendCount: null,
        fallbackStrategy: 1,

        plusObject: 0,
        cusType: 0, //新老客类型

        cusTemplateJSON: "",
      },
      ruleForm: {
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        allowLevel: "-1",
        activityName: "",
        openCardFollow: 0,
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "",
        isValidBlackList: 0,
        goShopSetting: 0,
        goShopAppId: "",
        goShopUrl: "",
        shareTitle: "我分享了一个答题导购活动给你，快来看看吧！", // 分享标题
        shareIntroduce: "我在京东有新发现，绝对适合你，速来围观～", // 分享简介
        sharePic: "https://cdn-image.yucrm.cn//hd/images/13315956_014a3db28f14478aa18b6d53b93bfd4c.png", // 分享图片
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: "", // 最小订单笔数
        orderCompleteMaxCount: "", // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: "", // 最小订单金额
        orderCompleteMaxPayment: "", // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteEndDay:"",
        lastOrderCompleteStartDay:"",
        lastOrderCompleteStartTime:"",
        lastOrderCompleteEndTime:"",

        priceType:0,
        isExposureItem:0,
        itemList:[],
      },
      tagDailogVisible: false,
      tagIndex: null,
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      levelList: [],
      activityStartTime: "",
      activityEndTime: "",
      giftList: [],
      templateObj: {},
      templateId: null,
      templateJson: {
        templateUItype: "",
      },

      currrentRgb:"", // 默认主题
    }
  },
  created() {
    this.ruleDTO.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleDTO.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.getLevel();
    useJdCrm(this);
    this.buriedPoint(1, "答题导购", "互动管理", "互动活动");
  },
  computed: {
    venderType() {
      return this.$store.getters.loginUserInfo.venderType
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    isStartEdit() {
      return this.activityData.isStart;
    },
    canSelectPrize() {
      return (row) => {
        let isCanSelect = false;
        isCanSelect = (this.activityData.isStart && !row.id) || !this.activityData.isStart
        return isCanSelect
      }
    },
    isDisabledNew() {
      let flag = true;
      if(!this.valueRow||JSON.stringify(this.valueRow) == '{}') {
        flag = false
      }
      if(this.valueRow&&this.valueRow.status==5) {
        flag = false
      }
      if(this.activityData&&(this.activityData.isCopy||this.activityData.singleCopy)) {
        flag = false
      }
      if((this.activityData.id==8||this.activityData.id==19||this.activityData.id==50)&&this.activityData.status==5) {
        flag = false
      }
      return flag
    }
  },
  methods: {
    editQuestion(item, index) {
			this.questionType = 'edit';
			this.questionIndex = index;
			this.questionData = JSON.parse(JSON.stringify(item));
			this.$nextTick(() => {
				this.questionDailogVisible = true;
			})
		},
    downPsd(url) {
			window.open(url, "_self");
		},
    cusTemplateJSONChange(data) {
      console.log("cusTemplateJSONChange", data);
      if(data.activityBgImg) {
        this.customerPaperwork.url = data.activityBgImg;
      }
      else {
        this.customerPaperwork.url = this.templateObj.url;
      }
    },
    // 上传
		handleUploadCommonSuccess(res, key) {
			if (res.code != 1) {
				this.$message.error(res.messaga);
			} else {
				this.customerPaperwork[key] = res.data;
			}
		},
    //判断尺寸方法 默认200*200
		imgchecked(file, width = 200, height = 200) {
			let _this = this;
			return new Promise((resolve, reject) => {
				let image = new Image();
				let _URL = window.URL || window.webkitURL;
				image.onload = function () {
					const valid = image.width == width && image.height == height;
					file.isFlag = valid;

					console.log(valid);
					if (valid) {
						console.log("Image loaded");
						resolve();
					} else {
						_this.$message.info("图片尺寸不符合要求，请重新上传");
						reject();
					}
				};
				image.src = _URL.createObjectURL(file);
			});
		},
    // 校验
		async beforeUploadCommon(file, width, height) {
			const status = await this.imgchecked(file, width, height);
			if (!status) {
				return false;
			}
			let type1 = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
			let sorts = [".png", ".jpg"];
			if (sorts.indexOf(type1) < 0) {
				this.$message.warning("所选文件格式不符，请重新选择");
				return false;
			}
		},
    addOrderWareBackstop(){
      this.isShowfallbackProducts = true;
    },
    handleDelete(index) {
			this.recommendProducts.splice(index, 1);
		},
    addOrderWare() {
			if (this.recommendProducts.length >= 50) {
				this.$message({
					message: "最多添加50个商品",
					type: "warning",
				});
				return;
			}
			this.recommendProducts.push({
				wareId: null,
				skuId: null,
				title: null,
				logo: "",
				price: null,
				prizeId: null,
				type: 0,
				sort: null,
				tags: [], // 标签
				couponObject: {
					sort: null,
					assetsId: null, // 资产项id(计划id优惠卷id商品id)
					prizeType: null, // 类型 固定为实物
					price: null, // 价格
					title: "", // 商品标题
					totalAmount: null, // 总共奖品数量
					singleAmount: 1, // 单份奖品数量 固定为1
					logo: null, // 自定义商品图片
					giftType: 1, //实物类型
					prizeObjectType: 10, //正装商品
					percentage: null, // 中奖率
					isShow: 1
				},
			})
		},
    deleteQuestion(index) {
			this.questionList.splice(index, 1);

      this.recommendProducts.forEach(item => {
        let newtags = [];
        item.tags.forEach(uuid => {
          this.questionList.forEach(question => {
            question.options.forEach(item => {
              if (item.uuid == uuid) {
                newtags.push(uuid);
              }
            });
          });
        });
        item.tags = newtags;
      });
      this.recommendProducts = JSON.parse(JSON.stringify(this.recommendProducts));
		},
    // 上移
		moveUp(index) {
			this.questionList[index] = this.questionList.splice(
				index - 1,
				1,
				this.questionList[index]
			)[0];
		},
		// 下移
		moveDown(index) {
			this.questionList[index] = this.questionList.splice(
				index + 1,
				1,
				this.questionList[index]
			)[0];
		},
    selectGoodsChangeCustomMarketingGoods(val){
      console.log("val======>", val);
      if(val){
        let item = {
          ...this.recommendProducts[this.prizeIndex],
          ...val[0],
        }
        let isPass = true;
        this.recommendProducts.forEach((it, index) => {
					if (it.skuId == item.skuId) {
						isPass = false
					}
				})
        if(!isPass){
          this.isShowCustomMarketingGoods = false;
          this.$nextTick(() => {
            this.isShowCustomMarketingGoods = true;
            this.$message.error("商品已存在");
          })
          return;
        }
        this.recommendProducts[this.prizeIndex] = item;
        this.recommendProducts = JSON.parse(JSON.stringify(this.recommendProducts));
        console.log("this.recommendProducts======>", item);
      }
      this.isShowCustomMarketingGoods = false;
    },
    selectfallbackProductsGoods(val) {
      if (val) {
        if(val.length>30){
          this.$message.error("最多添加30个商品");
          return
        }
        this.fallbackProducts = val;
      }
      this.isShowfallbackProducts = false;
    },
    // 改变数量值
    confirmAdd(num) {
      let { toAddBelong, toAddIndex } = this;
      if(toAddBelong == "recommendProducts"){
        this[toAddBelong][toAddIndex].couponObject.totalAmount = num;
        this.isShowAddNum = false;
        return;
      }
      this[toAddBelong][toAddIndex].totalAmount = num;
      this.isShowAddNum = false;
    },
    itemAddNumCoupon(arrStr, index) {
      this.toAddItem = {
        ...this[arrStr][index].couponObject,
        num: this[arrStr][index].couponObject.totalAmount,
      };
      if (!this.toAddItem.title || this.toAddItem.title == "谢谢参与") {
        this.$message.error("没有奖品不能设置数量！");
        return;
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr, index) {
      this.toAddItem = {
        ...this[arrStr][index],
        num: this[arrStr][index].totalAmount,
      };
      if (!this.toAddItem.title || this.toAddItem.title == "谢谢参与") {
        this.$message.error("没有奖品不能设置数量！");
        return;
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    selectTemplate(index, id, item) {
      console.log("item======>",item);
      this.templateObj = item;
      this.templateId = id;
      this.templateJson.templateUItype = index;
      this.initCustomizeData(item);
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        getAnswerGuideDetail(this.valueRow.id)
          .then((res) => {
            setBasicInformation(res.data, this);
            this.loading = false;
            this.getPolite();
          })
          .catch((res) => { });
      } else {
        this.activityStartTime = this.$getDate(30)[0];
        this.activityEndTime = this.$getDate(30)[1];
        this.hdTaskTemplateGroup();
      }
    },
    //会员等级
    getLevel() {
      if (this.valueRow && this.valueRow.id) {
        this.loading = true;
      }
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          this.getDetail();
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    // 模板类型
    async hdTaskTemplateGroup() {
      this.getPolite();
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },
    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: "",
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.loading = false;
      this.giftList =
        data.records && data.records.length > 0
          ? data.records.map((item) => {
            return {
              ...item,
              days: item.activityStartTime
                ? this.getDaysBetween(
                  item.activityStartTime,
                  item.activityEndTime
                )
                : "",
            };
          })
          : [];
      if (!this.templateId && this.giftList.length > 0) {
        let obj = this.giftList[0];
        this.templateObj = obj;
        this.templateId = obj.id;
        this.templateJson.templateUItype = 0;
        this.initCustomizeData(this.templateObj);
      } else if (this.templateId) {
        let arr = this.giftList.filter((item) => item.id == this.templateId);
        this.templateObj = arr[0];
        const configJson = this.templateObj.configJson
          ? JSON.parse(this.templateObj.configJson)
          : {};
        this.templateId = this.templateId;
        this.resetRgb(this.templateObj, configJson);
      }
      this.pageData.total = data.total * 1;
    },
    initCustomizeData(row) {
      this.customerPaperwork.url = row.url || "";
      this.customerPaperwork.url2 = row.url2 || "";
      this.customerPaperwork.titleColor = row.rgb || "";
      this.customerPaperwork.rgb2 = row.rgb2 || "";
      const configJson = row.configJson ? JSON.parse(row.configJson) : {};
      // 遍历 configJson，若 customerPaperwork 存在相同 key 则赋值
      Object.keys(configJson).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(this.customerPaperwork, key)) {
          this.customerPaperwork[key] = configJson[key];
        }
      });
      this.resetRgb(row, configJson);
    },
    resetRgb(row, configJson) {
      this.currrentRgb = row.rgb || "";
      this.templateObj = {
        ...row,
        ...configJson,
      }
      console.log(configJson);
    },
    onShopSetChange(value) {
      this.ruleForm.goShopAppId = '';
      this.ruleForm.goShopUrl = '';
    },
    deleteItem(index) {
      this.fallbackProducts.splice(index, 1);
    },
    handleTagComfirm(tags) {
      this.recommendProducts[this.tagIndex].tags = tags;
      this.tagDailogVisible = false;
    },
    setTag(index, row) {
      let isCanOpne = false
      this.questionList.forEach((item, i) => {
        if (item.questionWeight == 1) {
          isCanOpne = true
        }
      })
      if (!isCanOpne) {
        this.$message({
          message: "请先设置高权重题目",
          type: "warning",
        });
        return
      }
      this.tagDailogVisible = true;
      this.tagIndex = index;
      this.$refs.tagDailog.form.tags = row.tags;
    },
    openGoodsCoupon(index) {
      this.couponIndex = index;
      this.dialogCoupon = true;
    },
    //选择奖品弹窗
    openGoodsSelect(index) {
      console.log("index======>", index); 
      this.prizeIndex = index;
      this.isShowCustomMarketingGoods = true;
    },
    findTag(uuid) {
      let tagName = {
        type: 0,
        name: "-",
      };
      this.questionList.forEach((item, i) => {
        item.options.forEach((item2, j) => {
          if (item2.uuid == uuid) {
            if (item.type == 1) {
              tagName.type = item.type;
              tagName.name = item2.description;
            }
            else if (item.type == 4) {
              tagName.type = item.type;
              tagName.name = item2.picUrl;
            }
          }
        })
      })
      return tagName;
    },
    handleComfirm(form) {
      this.questionDailogVisible = false;
      if (this.questionType == 'create') {
        let newForm = {
          ...form,
        }
        this.questionList.push(newForm);
      } else {
        this.questionList[this.questionIndex] = JSON.parse(JSON.stringify(form));
        this.questionList = JSON.parse(JSON.stringify(this.questionList));
        // this.questionList.forEach(item => {
        // 	if (item.questionId == form.questionId) {
        // 		Object.assign(item, form);
        // 	}
        // });
      }
      this.recommendProducts.forEach(item => {
        let newtags = [];
        item.tags.forEach(uuid => {
          this.questionList.forEach(question => {
            question.options.forEach(item => {
              if (item.uuid == uuid) {
                newtags.push(uuid);
              }
            });
          });
        });
        item.tags = newtags;
      });
      this.recommendProducts = JSON.parse(JSON.stringify(this.recommendProducts));
    },
    addQuestion(type) {
      if (type == 'create' && this.questionList.length >= 50) {
        this.$message.warning("最多只能添加50题");
        return;
      }
      this.questionDailogVisible = true;
      this.questionType = type;
    },
    getTheData(data, prizeType) {
    },
    closeCoupon(val, params) {
      if (val) {
        if (this.venderType && val.couponType == 1) {
          return this.$message.warning("此类型奖品暂时不支持自营店铺！");
        }
        this.recommendProducts[this.couponIndex].couponObject = {
          ...this.recommendProducts[this.couponIndex].couponObject,
          prizeType: 1,
          couponType: params.couponType,
          title: params.name,
          singleAmount: 1,
          price: params.discount,
          batchKey: params.putkey || params.couponIdOrPutKey,
          validateDay: params.addDays,
          bindType: params.couponFrom,
          assetsId: params.assetsId,
          logo: params.logo?params.logo:"",
          quota: params.quota,
          prizeGoShop: params.prizeGoShop
        }
      }
      this.dialogCoupon = false;
    },
    clearCoupon(index) {
			this.recommendProducts[index].couponObject = {
				sort: null,
				assetsId: null, // 资产项id(计划id优惠卷id商品id)
				prizeType: null, // 类型 固定为实物
				price: null, // 价格
				title: "", // 商品标题
				totalAmount: null, // 总共奖品数量
				singleAmount: 1, // 单份奖品数量 固定为1
				logo: null, // 自定义商品图片
				giftType: 1, //实物类型
				prizeObjectType: 10, //正装商品
				percentage: null, // 中奖率
				isShow: 1
			};
		},
    closePrize(val, params) {
      if (val) {
        if (this.venderType && val.couponType == 1) {
          return this.$message.warning("此类型奖品暂时不支持自营店铺！");
        }
        console.log("params=====>", params);
        this.formalTable = [
          {
            ...this.formalTable[0],
            prizeType: 1,
            couponType: params.couponType,
            title: params.name,
            singleAmount: 1,
            price: params.discount,
            batchKey: params.putkey || params.couponIdOrPutKey,
            validateDay: params.addDays,
            bindType: params.couponFrom,
            assetsId: params.assetsId,
            logo: params.logo?params.logo:"",
            quota: params.quota,
            prizeGoShop: params.prizeGoShop
          },
        ];
      }
      this.dialogPrize = false;
    },
    //输入大于0的正整数
    validSe(data,max) {
      if (!data) return "";
      let filtered = (data+'').replace(/[^\d]/g, "");
      if (Number(filtered) < 1) {
        filtered = "";
      }
      if (max && Number(filtered) > max) {
        filtered = max;
      }
      return filtered;
    },
    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },
    async handleDialogCloseAnoth() {
      let obj = {
        pointActivityPrizeDTOList:[]
      };
      obj.subType = 87;
      obj.isKeyActivity = this.isKeyActivity;
      obj.condFollow = Number(this.ruleForm.condFollow);
      obj = this.deepClone(this.ruleForm);
      obj.placementPosition = this.placementPosition.join(',');
      obj.ruleDTO = this.deepClone(this.ruleDTO);
      obj.ruleDTO.openCardStartTime = this.actMember == 2 ? this.ruleDTO.openCardStartTime : "";
      obj.ruleDTO.openCardEndTime = this.actMember == 2 ? this.ruleDTO.openCardEndTime : "";

      obj.ruleDTO.openCardFollow = this.ruleForm.openCardFollow
      obj.ruleDTO.firstOpenCardTimeType = this.ruleForm.firstOpenCardTimeType
      obj.ruleDTO.openCardBeforeDay = this.ruleForm.openCardBeforeDay
      obj.ruleDTO.isForceRemind = false
      obj.ruleDTO.shareTitle = this.ruleForm.shareTitle
      obj.ruleDTO.shareIntroduce = this.ruleForm.shareIntroduce
      obj.ruleDTO.sharePic = this.ruleForm.sharePic
      obj.ruleDTO.goShopSetting = this.ruleForm.goShopSetting
      obj.ruleDTO.goShopAppId = this.ruleForm.goShopAppId
      obj.ruleDTO.goShopUrl = this.ruleForm.goShopUrl
      obj.templateJson = this.templateJson;
      obj.templateId = this.templateId;
      obj.questions = this.questionList.map((item, index) => {
        return {
          ...item,
          sort: index + 1,
          options: item.options.map((it, dex) => {
            return {
              ...it,
              sort: dex + 1,
            }
          }),
        }
      });
      obj.ruleDTO.fallbackProducts = this.fallbackProducts.map((item, index) => {
        let fallbackProductItem = {
          ...item,
          price: item.price || item.jdPrice,
          sort: index + 1,
        }
        return fallbackProductItem;
      });
      obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork);

      // 活动对象处理
      // 参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
      obj.allowLevel = this.ruleForm.partner && this.ruleForm.partner.length ? this.ruleForm.partner.join(",") : "";
      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel =
          this.ruleForm.partner && this.ruleForm.partner.length
            ? this.ruleForm.partner.join(",")
            : "";
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
      }
      obj.ruleDTO.orderCompleteLimitCount = this.ruleForm.orderCompleteLimitCount;
      obj.ruleDTO.orderCompleteMaxCount = this.ruleForm.orderCompleteMaxCount;
      obj.ruleDTO.orderCompleteLimitPayment =
        this.ruleForm.orderCompleteLimitPayment;
      obj.ruleDTO.orderCompleteMaxPayment = this.ruleForm.orderCompleteMaxPayment;
      obj.ruleDTO.lastOrderCompleteTimeType =
        this.ruleForm.lastOrderCompleteTimeType;
      if (obj.ruleDTO.lastOrderCompleteTimeType == 1) {
        obj.ruleDTO.lastOrderCompleteStartDay =
          this.ruleForm.lastOrderCompleteStartDay;
        obj.ruleDTO.lastOrderCompleteEndDay = this.ruleForm.lastOrderCompleteEndDay;
      } else if (obj.ruleDTO.lastOrderCompleteTimeType == 2) {
        obj.ruleDTO.lastOrderCompleteStartTime =
          this.ruleForm.lastOrderCompleteStartTime;
        obj.ruleDTO.lastOrderCompleteEndTime =
          this.ruleForm.lastOrderCompleteEndTime;
      }
      if (this.ruleDTO.couponMode == 1){
        obj.pointActivityPrizeDTOList = this.formalTable;
      }
      if(this.ruleDTO.couponMode == 2){
        obj.pointActivityPrizeDTOList = this.recommendProducts.map(item => {
          let couponObject = {
            ...item.couponObject,
            skuIds: item.skuId,
          }
          return couponObject;
        });
      }
      obj.recommendProducts = this.recommendProducts.map((item, index) => {
        let recommendProductItem = {
          ...item,
          price: item.price || item.jdPrice,
          sort: index + 1,
        }
        delete recommendProductItem.couponObject;
        return recommendProductItem;
      });
      if (this.checked == true || this.isDraft) {
        this.saveLoading = true;
        if (this.activityData.isStart){
          const params = useUpdateBasicInformation(obj, obj.pointActivityPrizeDTOList, this);
          updateCommon(params)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        }else{
          if (this.isDraft) {
            obj.status = 5;
            if(obj.pointActivityPrizeDTOList) {
              obj.pointActivityPrizeDTOList = obj.pointActivityPrizeDTOList.filter(item => item.assetsId);
            }
          }
          if (this.valueRow) {
            obj.pointActivityId = this.valueRow.id;
            obj.id = this.valueRow.id;
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
            // 草稿箱保存正式活动删除id
            if (!obj.status) {
              delete obj.id;
            }
          }
          if(this.activityData.isCopy){
            delete obj.id
            delete obj.pointActivityId;
          }
          saveOrUpdateAnswerGuide(obj).then((res) => {
            this.saveLoading = false;
            if (res.code == 1) {
              if (this.isDraft) {
                this.$message.success("保存成功！");
                this.$emit("returnBack", true);
              } else {
                this.$message.success(res.message);
                this.$router.push({
                  name: "throw2",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
              }
            } else {
              this.$message.error(res.message);
            }
          }).catch(() => {
            this.saveLoading = false;
          })
        }
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    // 下一步
    resetForm() {
         // 公共校验
      if (!useValidateBasicInformation(this)) {
        return;
      }

      if (this.questionList.length == 0) {
        this.$message.warning("请添加题目");
        return;
      }
      let isPassQuestion = false;
      this.questionList.forEach((item, index) => {
				if (item.questionWeight == 1 && item.type == 1) {
					isPassQuestion = true;
				}
			});
      if (!isPassQuestion) {
        this.$message.warning("至少设置一个高权重题目");
        return;
      }

      if(this.ruleDTO.couponMode == 1){
        if (!this.formalTable[0].assetsId || !this.formalTable[0].totalAmount || !this.formalTable[0].title) {
          this.$message.warning("请完善优惠券设置");
          return;
        }
        if(this.ruleDTO.unifiedCouponGrantType == 3){
          if(!this.ruleDTO.unifiedCouponGrantMaxCount){
            this.$message.warning("请输入最大领取次数");
            return;
          }
        }
      }
      if(this.ruleDTO.couponMode == 2){
        if(this.ruleDTO.productCouponGrantType == 3){
          if(!this.ruleDTO.productCouponGrantMaxCount){
            this.$message.warning("请输入最大领取次数");
            return;
          }
        }
      }

      if(this.recommendProducts.length == 0){
        this.$message.warning("请添加商品设置");
        return;
      }
      let isPassOrderWare = true;
	    this.recommendProducts.forEach((item, index) => {
        if(!item.skuId){
          isPassOrderWare = false;
        }
				if (item.tags.length == 0) {
					isPassOrderWare = false;
				}
				if (this.ruleDTO.couponMode == 2 && (!item.couponObject.assetsId || !item.couponObject.totalAmount || !item.couponObject.title)) {
					isPassOrderWare = false;
				}
			});
      if(!isPassOrderWare){
        this.$message.warning("请完善商品设置");
        return;
      }
      if(!this.ruleDTO.recommendCount){
        this.$message.warning("请输入推荐数量");
        return;
      }
      if(this.fallbackProducts.length == 0){
        this.$message.warning("请添加兜底商品");
        return;
      }
      if(!this.customerPaperwork.buttonWordText){
        this.$message.warning("请输入按钮文字");
        return;
      }
      if(!this.customerPaperwork.transitionPageText){
        this.$message.warning("请输入匹配中文案");
        return;
      }
      if(!this.customerPaperwork.matchSuccessfulOne|| !this.customerPaperwork.matchSuccessfulTwo || !this.customerPaperwork.matchSuccessfulThree){
        this.$message.warning("请输入匹配成功文案");
        return;
      }
      if(!this.customerPaperwork.similarGood){
        this.$message.warning("请输入相似好物文案");
        return;
      }
      if(!this.customerPaperwork.shopSpotlight){
        this.$message.warning("请输入店铺爆款文案");
        return;
      }
      if(!this.customerPaperwork.guideRecommendTag){
        this.$message.warning("请输入推荐标签文案");
        return;
      }
      if(!this.customerPaperwork.similarGoodTag){
        this.$message.warning("请输入相似好物标签文案");
        return;
      }
      if(!this.customerPaperwork.shopSpotlightTag){
        this.$message.warning("请输入店铺爆款标签文案");
        return;
      }
      if(this.ruleForm.goShopSetting == 1){
        if(!this.ruleForm.goShopAppId){
          this.$message.warning("请输入小程序appId");
          return;
        }
        // if(!this.ruleForm.goShopUrl){
        //   this.$message.warning("请输入页面路径path");
        //   return;
        // }
      }
      if(this.ruleForm.goShopSetting == 2){
        if(!this.ruleForm.goShopUrl){
          this.$message.warning("请输入指定链接");
          return;
        }
      }
      if(!this.ruleForm.sharePic){
        this.$message.warning("请分享图片");
        return;
      }
      if(!this.ruleForm.shareTitle){
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      if(!this.ruleForm.shareIntroduce){
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if(this.placementPosition.length == 0){
        this.$message.warning("请选择活动投放位置");
        return;
      }

      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      // // 奖品必选
      // if (this.prizeSetting.some((item) => !item.prizeType)) {
      //   this.$message.warning("请至少选择一个奖品");
      //   return;
      // }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
  },
}
</script>
<style lang="scss" scoped>
.common-flex1 {
  display: flex;
  align-items: center;
}

.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;

  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
  }

  .showTip {
    color: red;
    font-size: 14px;
  }

  .openTip {
    margin-left: 8px;
    color: #333333;
  }

  .rule_box {
    background-color: #f7f8fa;
    padding: 16px 16px 1px;
    border-radius: 4px;
    font-size: 14px;
  }

  .upload-box {
    width: 485px;
    padding: 20px 20px 1px;
    background: #f4f6fa;
    border-radius: 4px;
  }

  .textStyle {
    color: #333333;
  }

  .question-style {
    margin-left: 12px;
    display: flex;
    align-items: center;
    color: #3159ff;
  }
}

.ml8 {
  margin-left: 8px;
}

.mlr8 {
  margin: 0 8px;
}

.ml16 {
  margin-left: 16px;
}

.w100 {
  width: 100px;
}

.w120 {
  width: 120px;
}

.w80 {
  width: 80px;
}

.w160 {
  width: 160px;
}

.w200 {
  width: 200px;
}

.w60 {
  width: 60px;
}

.flex-c {
  display: flex;
  flex-direction: column;
}

.flex-r {
  display: flex;
  align-items: center;
}

/deep/ .el-tooltip__popper {
  font-size: 14px !important;
}
.draggable-box {
	margin-top: 10px;
	background: rgba(38, 112, 251, 0.06);
	padding: 10px;
	user-select: none;
	/* 标准语法 */
	-webkit-user-select: none;
	/* Chrome, Safari, Opera */
	-moz-user-select: none;
	/* Firefox */
	-ms-user-select: none;
	/* Internet Explorer/Edge */
}
.design {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.6);
	z-index: 99999;

	.design-box {
		position: relative;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 760px;

		.design-close {
			position: absolute;
			top: 10px;
			right: 10px;
			cursor: pointer;
			font-size: 25px;
			color: #979aa0;
			z-index: 5000;
		}

		.design-close:hover {
			color: #2768ff;
		}

		.design-url {
			width: 100%;
			height: auto;
		}
	}
}
</style>
